import { useSelector } from 'react-redux';

import { getHasInPersonSigningPermission } from '@app/store/user/authority/selectors';

export default function useShouldBlockInPersonSigning() {
  const hasPermission = useSelector(getHasInPersonSigningPermission);
  return {
    shouldBlockInPersonSigning: (hasInPersonSigner = true): boolean =>
      hasInPersonSigner && !hasPermission,
  };
}
